import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Table } from 'semantic-ui-react';
import { getFromLocalStorage } from '../../../../components/helper/authorizationHelper';
import { getAsync } from '../../../../components/helper/axiosHelper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import Userbanner from '../../../../components/elements/Userbanner';
import ImageViewModal from '../../../../components/elements/ImageViewModal';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import { PageHitCountApi } from '../../../../shared/Helper';

const Idea_Sugg_Up_View = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [apidata, setApidata] = useState([]);
  const [titleEn, setTitleEn] = useState('');
  const [descEn, setDescEn] = useState('');
  const [inputFile, setinputFile] = useState('');
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [fileBase64URL, setFileBase64URL] = useState('');
  const [selectedImageData, setSelectedImageData] = useState(null);
  const [allowedFileExtensions, setAllowedFileExtensions] = useState(['png', 'jpg', 'jpeg', 'pdf']);
  const [FileCheck, setFilecheck] = useState('');
  const [inputFileSize, setInputFileSize] = useState('');
  const [epUserID, setEpUserID] = useState(null);
  const [isLoad, setIsLoad] = useState(false);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const {pathname} = useLocation();


  const isLogin = () => {
    if (!token && !epUserID) {
      navigate('/donorLogin');
    }
  };

  const getEPUserData = async () => {
    setIsLoad(true);
    await getAsync('EP_UserAuthentication/EPUserByID/', {
      id: epUserID,
    })
      .then((response) => {
        setIsLoad(false);
        if (response != null) {
          setApidata(response?.data[0]);
        } else {
          toast.error(`${t('Record Not Found.')}`);
        }
      })
      .catch((error) => { });
  };

  const getEPIdeaServiceListById = async () => {
    await getAsync('EPIdeaService/EPIdeaServiceListById/', { id: id })
      .then((response) => {
        if (response != null) {
          setDescEn(response?.data[0].descEn);
          setTitleEn(response?.data[0].titleEn);
          setinputFile(response?.data[0].fileName);
          setFileBase64URL(response?.data[0].doc);
        } else {
          toast.error(t('Something went wrong, Please try again!'));
        }
      })
      .catch((error) => { });
  };

  const handleFileDownload = (e, fileDoc, fileName) => {
    e.preventDefault();

    try {
      const byteCharacters = atob(fileDoc);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const fileBlob = new Blob([byteArray]);
      const fileUrl = URL.createObjectURL(fileBlob);

      const downloadLink = document.createElement('a');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName || 'downloaded_file'; // Use a default name if fileName is not available

      document.body.appendChild(downloadLink);
      downloadLink.click();

      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    getEPIdeaServiceListById();

    if (epUserID !== null) {
      getEPUserData();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  const openModal = (e, data) => {
    e.preventDefault();
    setSelectedImageData(data);
    setGridModalOpen(true);
  };

  const closeModal = (e) => {
    e.preventDefault();
    setGridModalOpen(false);
  };

  return (
    <>
      {isLogin && (
        <div className="py-5 lg:py-10">
          <Userbanner />
          {isLoad ? (
            <LoadingAnimation
              imageStyling={''}
              styling={'flex items-center py-5 align-middle justify-center space-x-2'}
            />
          ) : (
            <div className="container-fluid ">
              <div className="row justify-center">
                <div className=" col-lg-11">
                  <form>
                    <div className="card   ">
                      <div className="card-header text-center">
                        <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">
                          {t('Idea Suggestion View')}
                        </h1>
                      </div>
                      <div className="card-body">
                        <div className="row flex flex-row">
                          <div className="col-sm-12 col-md-4 ">
                            <div className="w-full px-2 form-group">
                              <label className="my-2">{t('Full Name')}</label>
                              <input
                                type="text"
                                value={apidata?.fullName}
                                disabled
                                style={{
                                  cursor: 'no-drop',
                                }}
                                className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                              />
                            </div>
                          </div>

                          <div className="col-sm-12 col-md-4 ">
                            <div className="form-group px-2 w-full ">
                              <label className="my-2">{t('Mobile Number')}</label>
                              <input
                                type="text"
                                className="w-full  border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  block"
                                disabled
                                value={apidata?.mobile}
                                style={{
                                  cursor: 'no-drop',
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-sm-12 col-md-4">
                            <div className="px-2 w-full form-group">
                              <label className="my-2">{t('Email')}</label>
                              <input
                                type="text"
                                className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block"
                                disabled
                                value={apidata?.email}
                                style={{
                                  cursor: 'no-drop',
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <br />
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Suggestion')}</h2>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography></Typography>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>{t('Title')}</label>
                                  <input
                                    type="text"
                                    value={titleEn}
                                    disabled
                                    style={{ cursor: 'no-drop' }}
                                    className="  border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                                    placeholder={t('Enter The title')}
                                    onChange={(e) => setTitleEn(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>{t('Description')}</label>
                                  <textarea
                                    type="text"
                                    value={descEn}
                                    disabled
                                    style={{ height: '250px', cursor: 'no-drop' }}
                                    className=" w-full border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen my-2 block"
                                    placeholder={t('Description')}
                                    onChange={(e) => setDescEn(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>

                        <br />
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Documents Upload')}</h2>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography></Typography>
                            <div className="row">
                              <div className="col-lg-12 overflow-x-auto">
                                <br />
                                <Table className="table ">
                                  <Table.Header className="bg-customgreen ">
                                    <Table.Row className="text-sm font-medium">
                                      <Table.Cell className="text-white">{t('sNo')}</Table.Cell>
                                      <Table.Cell className="text-white">{t('File')}</Table.Cell>
                                      <Table.Cell className="text-white">{t('Action')}</Table.Cell>
                                    </Table.Row>
                                  </Table.Header>
                                  <Table.Body>
                                    <Table.Row className="text-sm font-normal">
                                      <Table.Cell className="font-normal">1</Table.Cell>
                                      <Table.Cell className="font-normal">
                                        {!allowedFileExtensions.includes(FileCheck) || inputFileSize > 1097152 ? (
                                          <label
                                            style={{
                                              fontWeight: '500',
                                            }}
                                          >
                                            {inputFile}
                                          </label>
                                        ) : (
                                          <label>{inputFile}</label>
                                        )}
                                      </Table.Cell>
                                      <Table.Cell className="font-normal">
                                        <button
                                          onClick={(e) => handleFileDownload(e, fileBase64URL, inputFile)}
                                          className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                          style={{
                                            margin: '5px',
                                          }}
                                        >
                                          <FileDownloadOutlinedIcon />
                                        </button>{' '}
                                        {/* Modal Create */}
                                        <>
                                          <button
                                            className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                            onClick={(e) => openModal(e, fileBase64URL)}
                                            style={{
                                              margin: '5px',
                                            }}
                                          >
                                            <VisibilityOutlinedIcon />
                                          </button>

                                          {/* <MDBModal tabIndex="-1" show={gridModalOpen} setShow={setGridModalOpen}>
                                            <MDBModalDialog>
                                              <MDBModalContent>
                                                <MDBModalHeader>
                                                  <MDBModalTitle className="">
                                                    {t('Suggestion')}
                                                  </MDBModalTitle>
                                                  <MDBBtn
                                                    type="button"
                                                    className="btn-close"
                                                    color="none"
                                                    onClick={(e) => closeModal(e)}
                                                  ></MDBBtn>
                                                </MDBModalHeader>
                                                <MDBModalBody>
                                                  <div className="container-fluid bd-example-row h-52">
                                                    {selectedImageData && (
                                                      <img
                                                        className="max-h-52 w-full"
                                                        src={`data:image/jpeg;base64,${selectedImageData}`}
                                                        alt="img.jpg"
                                                      />
                                                    )}
                                                  </div>
                                                </MDBModalBody>
                                                <MDBModalFooter>
                                                  <MDBBtn
                                                    color="secondary"
                                                    className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-4 py-2 text-center me-1"
                                                    onClick={closeModal}
                                                  >
                                                    {t('close')}
                                                  </MDBBtn>
                                                </MDBModalFooter>
                                              </MDBModalContent>
                                            </MDBModalDialog>
                                          </MDBModal> */}
                                          <ImageViewModal
                                            showModal={gridModalOpen}
                                            setShowModal={setGridModalOpen}
                                            closeModal={closeModal}
                                            title={'Suggestion'}
                                            renderLink={''}
                                            imgDoc={selectedImageData}
                                          />
                                        </>
                                        {/* end */}
                                      </Table.Cell>
                                    </Table.Row>
                                  </Table.Body>
                                </Table>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                      <div className="card-footer">
                        <Link
                          to={'/IdeaSuggUPRegistrationList'}
                          className="text-white w-24 bg-customgreen ms-2 hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                        >
                          {t('Back')}
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Idea_Sugg_Up_View;
